import { render } from "./Top5HelpfulTips.vue?vue&type=template&id=7b0e9f1a&scoped=true"
import script from "./Top5HelpfulTips.vue?vue&type=script&lang=js"
export * from "./Top5HelpfulTips.vue?vue&type=script&lang=js"

import "./Top5HelpfulTips.vue?vue&type=style&index=0&id=7b0e9f1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b0e9f1a"]])

export default __exports__